module.exports = __webpack_public_path__ + "static/img/RW1566_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RW1566_1.png
// module id = LU8h
// module chunks = 0